export default __webpack_public_path__ + "static/media/Flaticon.59cc8aa9.ttf";